import PropTypes from 'prop-types'
import React from 'react'

import ButtonTiny from 'components/ButtonTiny/ButtonTiny'
import DefaultTooltip from 'components/DefaultTooltip/DefaultTooltip'

import styles from './UpdateButton.scss'

const propTypes = {
    disabled: PropTypes.bool,
    handleClick: PropTypes.func.isRequired,
    tooltipTitle: PropTypes.node,
    tooltipMessage: PropTypes.node,
}

const TOOLTIP_ID = 'updateButtonTooltip'

const UpdateButton = props => (
    <ButtonTiny type='secondary' handleClick={props.handleClick} disabled={props.disabled}>
        <span className={styles.icon} data-tip data-for={TOOLTIP_ID}/>
        <DefaultTooltip
            id={TOOLTIP_ID}
            title={props.tooltipTitle}
            message={props.tooltipMessage}
        />
    </ButtonTiny>
)

UpdateButton.propTypes = propTypes

export default UpdateButton



// WEBPACK FOOTER //
// ./components/UpdateButton/UpdateButton.jsx